import { Component, computed, EventEmitter, inject, Input, Output } from '@angular/core';
import { UIStreamlineIconComponent } from "../../../../../ui/streamline-icon/ui-streamline-icon.component";
import { AvatarComponent } from "../../../../../shared/components/avatar/avatar.component";
import { PerformLogEvidence } from '../../perform-log.type';
import { UserService } from 'src/app/services/user.service';
import { DateToDdMmmYyyyPipe } from 'src/app/shared/pipes/date-to-dd-mmm-yyyy.pipe';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedConfirmationModalComponent } from 'src/app/shared/popups/shared-confirmation-modal/shared-confirmation-modal.component';

@Component({
  selector: "app-perform-log-evidence-card",
  imports: [UIStreamlineIconComponent, AvatarComponent, DateToDdMmmYyyyPipe],
  templateUrl: "./perform-log-evidence-card.component.html",
  styleUrl: "./perform-log-evidence-card.component.scss",
})
export class PerformLogEvidenceCardComponent {
  @Input({ required: true }) evidence: PerformLogEvidence;
  @Output() deleteEvidenceChange = new EventEmitter();
  private modalService = inject(NgbModal);
  userService = inject(UserService);

  deleteEvidence() {
    const activeModal = this.modalService.open(
      SharedConfirmationModalComponent,
      {
        backdrop: "static",
        size: "lg",
      }
    );
    activeModal.componentInstance.title = `Are you sure you want to delete this evidence?`;
    activeModal.componentInstance.content = `<p>You are about to delete this evidence . Please confirm the selection.</p>`;
    activeModal.componentInstance.buttonText = "Delete";
    activeModal.componentInstance.buttonClass = "danger";
    activeModal.componentInstance.hasCancelButton = true;
    activeModal.result.then((res) => {
      if (res === "confirm") {
        this.deleteEvidenceChange.emit();
      }
    });
  }

  openLink() {
    window.open(this.evidence.link, "_blank");
  }

  get managerFullName() {
    return (
      this.userService.allOrgUserDictionaryByUserID[
        this.evidence?.managerUserID
      ]?.userDetail?.fullName || this.userService.user?.value.fullName
    );
  }
}
